import { render, staticRenderFns } from "./AdminAdvertAdd.vue?vue&type=template&id=6578d410&scoped=true"
import script from "./AdminAdvertAdd.vue?vue&type=script&lang=js"
export * from "./AdminAdvertAdd.vue?vue&type=script&lang=js"
import style0 from "./AdminAdvertAdd.vue?vue&type=style&index=0&id=6578d410&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6578d410",
  null
  
)

export default component.exports